var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 9.16667V5.66667C19.6667 4.378 18.622 3.33333 17.3333 3.33333H3.33333C2.04467 3.33333 1 4.378 1 5.66667V9.16667M19.6667 9.16667V19.6667C19.6667 20.9554 18.622 22 17.3333 22H3.33333C2.04467 22 1 20.9554 1 19.6667V9.16667M19.6667 9.16667H1M5.66667 1V5.66667M15 1V5.66667",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25001 11.5H3.91668C3.59451 11.5 3.33334 11.7612 3.33334 12.0833V14.4167C3.33334 14.7388 3.59451 15 3.91668 15H6.25001C6.57218 15 6.83335 14.7388 6.83335 14.4167V12.0833C6.83335 11.7612 6.57218 11.5 6.25001 11.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5H9.16668C8.84451 11.5 8.58334 11.7612 8.58334 12.0833V14.4167C8.58334 14.7388 8.84451 15 9.16668 15H11.5C11.8222 15 12.0833 14.7388 12.0833 14.4167V12.0833C12.0833 11.7612 11.8222 11.5 11.5 11.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 11.5H14.4167C14.0945 11.5 13.8333 11.7612 13.8333 12.0833V14.4167C13.8333 14.7388 14.0945 15 14.4167 15H16.75C17.0722 15 17.3333 14.7388 17.3333 14.4167V12.0833C17.3333 11.7612 17.0722 11.5 16.75 11.5Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.703a40517249fd41e5915fd4683a7ac3.svg";
export { ForwardRef as ReactComponent };